"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeFragments = void 0;

var _isPrimitive = require("./isPrimitive");

var mergeFragments = function mergeFragments() {
  var fragments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var current = arguments.length > 1 ? arguments[1] : undefined;
  var last = fragments.pop();

  if ((0, _isPrimitive.isPrimitive)(last)) {
    fragments.push("".concat(last).concat(current));
  } else {
    Array.prototype.push.apply(fragments, [last, current]);
  }
};

exports.mergeFragments = mergeFragments;